module.exports = __webpack_public_path__ + "img/ja_by_piotrek2.31baf6b8.jpg";